import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    drivers: [],
    listView: false,
    sortBy: '',
    filterBy: '',
    loadingDrivers: false,
    contractor: '',
    showDetails: false,
    showInactive: false,
    selectedRecordType: 'Active'
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', '')
      context.commit('modifyDriver', '')
      context.commit('modifyVehicle', '')
      context.commit('modifySite', '')
      context.commit('resetTrips')
    }
  },
  getters: {
    getDrivers: state => state.drivers
  }
}
